import { CenterScreenComponent, DocumentForm } from '../../components';

import { COLORS } from '../../styles/colors';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import styled from 'styled-components';
import { useMeQuery } from '../../generated/graphql';

type CreateDocumentScreenProps = RouteComponentProps;

const PageContainer = styled.div`
    min-height: 100vh;
    background: ${COLORS.white};
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 3rem 0 2rem 0;
`;

const FormColumn = styled.div`
    background: transparent;
    max-width: 600px;
    width: 100%;
    margin-top: 2rem;
    display: flex;
    flex-direction: column;
    align-items: stretch;
`;

const Title = styled.h3`
    color: ${COLORS.primary};
    font-weight: 700;
    margin-bottom: 2rem;
    text-align: left;
`;

export const CreateDocumentScreen: React.FC<CreateDocumentScreenProps> = ({}) => {
    const { data } = useMeQuery();

    return (
        <PageContainer>
            <FormColumn>
                <Title>Додавання документу</Title>
                <DocumentForm />
            </FormColumn>
        </PageContainer>
    );
};
